import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import { pickHTMLProps } from 'pick-react-known-prop';
import capitalize from '@material-ui/core/utils/capitalize';
import withThemeProps from '@sprinx/react-mui-components/withThemeProps';
var useStyles = makeStyles(function (theme) {
  return {
    root: _extends({}, theme.typography.body1),
    decorationNone: {
      textDecoration: 'none'
    },
    decorationStrike: {
      textDecoration: 'line-through'
    },
    colorInherit: {
      color: 'inherit'
    },
    colorPrimary: {
      color: theme.palette.primary.main
    },
    colorSecondary: {
      color: theme.palette.secondary.main
    },
    colorTextPrimary: {
      color: theme.palette.text.primary
    },
    colorTextSecondary: {
      color: theme.palette.text.secondary
    },
    colorError: {
      color: theme.palette.error.main
    },
    sizeSmall: {
      fontSize: theme.typography.body2.fontSize
    },
    sizeMedium: {
      fontSize: theme.typography.body1.fontSize
    },
    sizeLarge: {
      fontSize: theme.typography.subtitle1.fontSize
    },
    label: {},
    labelStart: {
      marginRight: theme.spacing(1)
    },
    labelEnd: {
      marginLeft: theme.spacing(1)
    },
    price: {
      whiteSpace: 'nowrap'
    }
  };
}, {
  name: 'SxComProductPriceElementBase'
});

function ProductPriceElementBase(_ref) {
  var children = _ref.children,
      pClasses = _ref.classes,
      className = _ref.className,
      color = _ref.color,
      Component = _ref.component,
      ComponentContent = _ref.componentContent,
      ComponentLabel = _ref.componentLabel,
      decoration = _ref.decoration,
      labelEnd = _ref.labelEnd,
      labelStart = _ref.labelStart,
      size = _ref.size,
      rest = _objectWithoutProperties(_ref, ["children", "classes", "className", "color", "component", "componentContent", "componentLabel", "decoration", "labelEnd", "labelStart", "size"]);

  var classes = useStyles({
    classes: pClasses
  });
  return /*#__PURE__*/React.createElement(Component, _extends({}, pickHTMLProps(rest), {
    className: clsx(classes.root, className, decoration && classes["decoration".concat(capitalize(decoration))], color && classes["color".concat(capitalize(color))], size && classes["size".concat(capitalize(size))])
  }), labelStart && /*#__PURE__*/React.createElement(ComponentLabel, {
    className: clsx(classes.label, classes.labelStart)
  }, labelStart), /*#__PURE__*/React.createElement(ComponentContent, {
    className: classes.price
  }, children), labelEnd && /*#__PURE__*/React.createElement(ComponentLabel, {
    className: clsx(classes.label, classes.labelEnd)
  }, labelEnd));
}

ProductPriceElementBase.propTypes = {
  children: PropTypes.node.isRequired,
  classes: PropTypes.shape({
    label: PropTypes.string,
    labelEnd: PropTypes.string,
    labelStart: PropTypes.string,
    price: PropTypes.string,
    root: PropTypes.string
  }),
  className: PropTypes.string,
  color: PropTypes.oneOf(['initial', 'inherit', 'primary', 'secondary', 'textPrimary', 'textSecondary', 'error']),
  component: PropTypes.elementType,
  componentContent: PropTypes.elementType,
  componentLabel: PropTypes.elementType,
  decoration: PropTypes.oneOf(['none', 'strike']),
  labelEnd: PropTypes.node,
  labelStart: PropTypes.node,
  size: PropTypes.oneOf(['large', 'medium', 'small'])
};
ProductPriceElementBase.defaultProps = {
  classes: undefined,
  className: undefined,
  color: 'initial',
  component: 'div',
  componentContent: 'span',
  componentLabel: 'span',
  decoration: 'none',
  labelEnd: undefined,
  labelStart: undefined,
  size: 'medium'
};
export default withThemeProps({
  name: 'SxComProductPriceElementBase'
})(ProductPriceElementBase);